import React, { useState } from "react";
import dayjs from "dayjs";
import { PageHeader, PageContainer, SectionCard, DataTable, EntityCell, StatusTag } from "../../../components/admin";
import { Tag } from "antd";
import { useListQuery } from "../../../utils/useListQuery";
import { ticketService } from "../services/ticketService";
import TicketsFilterBar from "../components/TicketsFilterBar";
import TicketDetailDrawer from "../components/TicketDetailDrawer";
import { STATUS_LABELS, PRIORITY_LABELS } from "../data/supportMockData";

const PRIORITY_COLOR = { Low: "default", Medium: "blue", High: "orange", Urgent: "red" };

export default function SupportPage() {
  const {
    rows, total, loading, filters, page, pageSize,
    setPage, setPageSize, updateFilters, resetFilters, refetch,
  } = useListQuery(
    ticketService.getTickets,
    { search: "", status: undefined, priority: undefined, dateRange: null },
  );
  const [detailState, setDetailState] = useState({ open: false, ticket: null, loading: false });

  const handleView = async (record) => {
    setDetailState({ open: true, ticket: null, loading: true });
    const detail = await ticketService.getTicketById(record.id);
    setDetailState({ open: true, ticket: detail.data, loading: false });
  };

  const refreshDetail = async (closeDrawer = true) => {
    const detail = await ticketService.getTicketById(detailState.ticket.id);
    setDetailState({ open: !closeDrawer, ticket: detail.data, loading: false });
    refetch();
  };

  const columns = [
    { title: "Talep No", dataIndex: "id", key: "id", width: 90, render: (v) => `#${v}` },
    {
      title: "Kullanıcı",
      key: "user",
      width: 200,
      render: (_, r) => <EntityCell title={r.userEmail} subtitle={`#${r.userId}`} avatarColor="#2F6FED" />,
    },
    { title: "Konu", dataIndex: "subject", key: "subject", width: 220 },
    {
      title: "Öncelik",
      dataIndex: "priority",
      key: "priority",
      width: 100,
      render: (v) => <Tag color={PRIORITY_COLOR[v]}>{PRIORITY_LABELS[v] ?? v}</Tag>,
    },
    {
      title: "Durum",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (v) => <StatusTag status={v}>{STATUS_LABELS[v] ?? v}</StatusTag>,
    },
    {
      title: "Oluşturulma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      sorter: (a, b) => new Date(a.createdAt) - new Date(b.createdAt),
      render: (v) => dayjs(v).format("DD MMM YYYY"),
    },
    {
      title: "Güncellenme Tarihi",
      key: "updatedAt",
      width: 150,
      render: (_, r) => dayjs(r.closedAt ?? r.createdAt).format("DD MMM YYYY"),
    },
  ];

  return (
    <PageContainer>
      <PageHeader
        crumbs={[{ label: "Kontrol Paneli", path: "/admin" }, { label: "Destek" }]}
        title="Destek"
        description="Kullanıcı destek taleplerini yönetin."
      />

      <TicketsFilterBar filters={filters} onChange={updateFilters} onReset={resetFilters} />

      <SectionCard>
        <DataTable
          columns={columns}
          dataSource={rows}
          loading={loading}
          scrollX={1000}
          emptyDescription="Bu filtrelerle eşleşen destek talebi bulunamadı."
          onRow={(record) => ({ className: "mbfit-row-clickable", onClick: () => handleView(record) })}
          pagination={{
            current: page,
            pageSize,
            total,
            onChange: (nextPage, nextPageSize) => {
              setPage(nextPage);
              setPageSize(nextPageSize);
            },
          }}
        />
      </SectionCard>

      <TicketDetailDrawer
        open={detailState.open}
        ticket={detailState.ticket}
        loading={detailState.loading}
        onClose={() => setDetailState({ open: false, ticket: null, loading: false })}
        onChanged={refreshDetail}
      />
    </PageContainer>
  );
}
